export const coords = {
    Bratislava: {
        lat: 48.1571,
        lng: 17.1056938,
        name: 'Bratislava'
    }
}

export const defaultMapCenter = {
    lat: 48.147156,
    lng: 17.121303
}

export const coordsList = Object.values(coords)
